import { createContext, useContext } from 'react';

import type { QueryStringParamUpdateOptions } from '@app/hocs/query-string-params/types';

import type { FilterValue } from './types';

export type FilterItemContextType<T extends FilterValue> = {
  value: T | null;
  defaultValue: T | null;
  // A hack to make the onChange callback parameter bivariant,
  // so that we can pass generic types to the context provider.
  // See https://stackoverflow.com/questions/52667959/what-is-the-purpose-of-bivariancehack-in-typescript-types
  // for more details on why this is necessary.
  onChange: {
    bivarianceHack(value: T | null, options?: QueryStringParamUpdateOptions): void;
  }['bivarianceHack'];
};

export const FilterItemContext = createContext<FilterItemContextType<FilterValue> | null>(null);

export function useFilterItemContext<T extends FilterValue>() {
  const context = useContext(FilterItemContext);

  if (!context) {
    throw new Error('useFilterItemContext must be used within a FilterItemContext.Provider');
  }

  return context as FilterItemContextType<T>;
}
